import { createSlice } from '@reduxjs/toolkit';

export type AppUpdateState = 'redundant' | `updatefound-${number}`;

const AppUpdateSlice = createSlice({
  name: 'appUpdate',
  initialState: 'redundant' as AppUpdateState,
  reducers: {
    appUpdateFound() {
      return `updatefound-${Date.now()}`;
    },
    appUpdateRedundant() {
      return `redundant`;
    },
  },
});

export const { appUpdateFound, appUpdateRedundant } = AppUpdateSlice.actions;

export default AppUpdateSlice.reducer;
